import React from "react";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    FormHelperText,
} from "@mui/material";

export const CURRENCY_OPTIONS = [
    { code: "USD", flag: "🇺🇸", label: "USD — US Dollar" },
    { code: "CAD", flag: "🇨🇦", label: "CAD — Canadian Dollar" },
    { code: "EUR", flag: "🇪🇺", label: "EUR — Euro" },
    { code: "GBP", flag: "🇬🇧", label: "GBP — British Pound" },
    { code: "CNY", flag: "🇨🇳", label: "CNY — Chinese Yuan" },
    { code: "MXN", flag: "🇲🇽", label: "MXN — Mexican Peso" },
];

/**
 * CurrencyPicker
 *
 * Single select for choosing the currency an expense was entered in.
 *
 * Props:
 *   value    - selected currency code (e.g. "USD")
 *   onChange - called with the selected code
 *   error    - error string to display below the select
 *   disabled - disables the select
 *   required - marks the label as required
 */
export default function CurrencyPicker({
    value = "USD",
    onChange,
    error = "",
    disabled = false,
    required = false,
}) {
    const label = required ? "Currency *" : "Currency";

    return (
        <FormControl fullWidth error={Boolean(error)} disabled={disabled}>
            <InputLabel id="currency-picker-label">{label}</InputLabel>
            <Select
                labelId="currency-picker-label"
                id="currency-picker-select"
                value={value}
                label={label}
                onChange={(e) => onChange(e.target.value)}
                renderValue={(selected) => {
                    const option = CURRENCY_OPTIONS.find((c) => c.code === selected);
                    return (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            {option ? option.flag : selected}
                        </Box>
                    );
                }}
            >
                {CURRENCY_OPTIONS.map((c) => (
                    <MenuItem key={c.code} value={c.code}>
                        {c.flag} {c.label}
                    </MenuItem>
                ))}
            </Select>
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
}
